/**
 * @module attributeResults
 */
import { createReducer } from '@reduxjs/toolkit';
import { surveyReportingActions } from '~/behaviors/actions/survey_reporting.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { accountActions } from '~/behaviors/actions/account.actions';

const defaultState = {};

const reset = () => defaultState;

const mergeAttributeResults = (state, action) => {
  const attributeResults = action.payload?.entities?.attributeResults || {};

  return { ...state, ...attributeResults };
};

const attributeResults = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(accountActions.logout.pending, reset);
  builder.addCase(accountActions.switchCompany.pending, reset);

  builder.addCase(surveyReportingActions.fetchReportingResults.fulfilled, mergeAttributeResults);

  builder.addCase(surveyReportingActions.fetchReportingAttributeResult.fulfilled, mergeAttributeResults);
});

export default attributeResults;
